import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportTimeseriesSalesPage } from './report-timeseries-sales.page';

const routes: Routes = [
  {
    path: '',
    component: ReportTimeseriesSalesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportTimeseriesSalesPageRoutingModule {}
